import { Container } from 'ui';
import { Link, Typography } from 'omakase';
import { privacyEmailAnchor, privacyPolicyLink, termsLink } from 'utils/legal/termsUtils';
import { title } from 'routes/legal/cookieRouteCssDefs';

const CookieRoute: React.FunctionComponent = () => {
  return (
    <div className="Legal">
      <Container maxWidth="md">
        <Typography css={title} component="h1" variant="heading01" align="center" mb={4}>
          Cookie Policy
        </Typography>
        <Typography component="h2" variant="heading03" mb={2}>
          Effective Date: December 21, 2023
        </Typography>
        <Typography variant="body02" paragraph mb={2}>
          This Cookie Policy describes how Tock uses cookies and similar technologies to provide,
          customize, evaluate, improve, promote, and protect our Services. Note that any capitalized
          terms not defined in this Cookie Policy have the meanings set forth in our {termsLink()}{' '}
          or {privacyPolicyLink()}. If you have any comments or questions about this Cookie Policy,
          feel free to contact us at {privacyEmailAnchor()}.
        </Typography>
        <Typography variant="body02" paragraph mb={2}>
          <b>Cookies.</b> Cookies are small files sent to your device when you visit a site. There
          are also similar technologies which are not technically cookies that are used for similar
          purposes, such as local storage objects. When this Cookie Policy refers to “Cookies,” it
          is referring to both cookies and such similar technologies. Cookies and these similar
          technologies serve a variety of functions, like enabling us to remember certain
          information you provide to us as you navigate between pages on the Services. We use
          Cookies on our Services for the following purposes:
        </Typography>

        <div>
          <ul>
            <Typography component="li" variant="body02">
              <b>Authentication, Customization, Security and Other Functional Cookies.</b> Cookies
              help us verify your Account and device and determine when you`re logged in, so we can
              make it easier for you to access the Services and provide the appropriate experiences
              and features. We also use Cookies to help prevent fraudulent use of login credentials
              and to remember choices you`ve made on the Services.
            </Typography>
            <Typography component="li" variant="body02">
              <b>Performance And Analytics.</b> Cookies help us analyze how the Services are being
              accessed and used, and enable us to track performance of the Services. For example, we
              use Cookies to determine if you viewed a page or opened an email. This helps us
              provide you with information that you find interesting.
            </Typography>
            <Typography component="li" variant="body02">
              <b>Third Parties.</b> Third Party Services may use cookies to help you sign into their
              services from our Services. Any such third party cookie usage is governed by the
              policy of the third party placing the cookie.Third Parties. Third Party Services may
              use cookies to help you sign into their services from our Services. Any such third
              party cookie usage is governed by the policy of the third party placing the cookie.
            </Typography>
            <Typography component="li" variant="body02">
              <b>Tock Ads.</b> We partner with third party publishers, advertising networks and
              service providers to manage our ads on other sites. Our third party partners may set
              cookies on your device or browser to gather information about your activities on the
              Services and other sites you visit, in order to provide you with Tock ads. For
              example, if you visit the Services and also use a social media platform, you may see a
              Tock ad in your social media newsfeed or timeline.
            </Typography>
            <Typography component="li" variant="body02">
              <b>Opting Out.</b> You can set your browser to not accept cookies, but this may limit
              your ability to use the Services. We currently don`t respond to DNT:1 signals from
              browsers visiting our Services. You can also opt out of receiving interest-based ads
              from certain ad networks{' '}
              <Link href="https://www.networkadvertising.org/choices/">here</Link> (or if located in
              the European Union, <Link href="https://www.youronlinechoices.eu/">here</Link>).
            </Typography>
          </ul>
        </div>

        <Typography variant="body02" paragraph mb={2}>
          Device Identifiers. We use device identifiers on Tock web and mobile applications to
          track, analyze and improve the performance of the Services and our ads.
        </Typography>
        <Typography variant="body02" paragraph mb={2}>
          Third Party Tags. We use and manage third party tags on the website and associated domains
          of www.exploretock.com and on Tock web and mobile applications. Third party tags may take
          the form of pixels or tracking snippets. We use pixels to learn how you interact with our
          site pages and emails, and this information helps us and our ad partners provide you with
          a more tailored experience. We use tracking snippets to capture data from your browser,
          make requests to a third party partner or set cookies on your device to store data. For
          example, if you see a Tock ad on a social media platform and then make a Paid Booking, we
          may use a tag to reduce the number of Tock ads you see on that platform. We use{' '}
          <Link href="https://www.google.com/analytics/tag-manager/use-policy/">
            Google Tag Manager
          </Link>{' '}
          to manage our third party tag usage. This may cause other tags to be activated which may,
          for their part, collect data and set cookies under certain circumstances. Google Tag
          Manager does not store this data.
        </Typography>
        <Typography variant="body02" paragraph mb={2}>
          We may update this Cookie Policy from time to time. When we make changes, we`ll update the
          “Effective Date” at the top of the Cookie Policy and post it on our sites. We encourage
          you to check back periodically to review this Cookie Policy for any changes since your
          last visit.
        </Typography>
      </Container>
    </div>
  );
};

export default CookieRoute;
